import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App as AntApp } from 'antd';
import ErrorBoundry from './components/Utility/ErrorBoundry';
import RequireAuth from './components/RequireAuth';
import Admin from './components/Admin/Admin';
import LoginPage from './pages/LoginPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import PrivacyPolicyPage from './pages/Legal/PrivacyPolicy';
import TermsAndConditionsPage from './pages/Legal/TermsAndConditions';
import SupportPage from './pages/Support/SupportPage';
import DeleteAccountPage, { ConfirmAccountDeletionPage } from './pages/DeleteAccount';

const App = () => {
  return (
    <ErrorBoundry>
      <AntApp>
        <BrowserRouter>
          <Routes>
            {/* Rutas públicas */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/auth/activate" element={<ResetPasswordPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/eliminar-datos" element={<DeleteAccountPage />} />
            <Route path="/confirmar_eliminacion/:code" element={<ConfirmAccountDeletionPage />} />
            
            {/* Rutas privadas: Requieren autenticación */}
            <Route
              path="/"
              element={
                <RequireAuth>
                  <Admin />
                </RequireAuth>
              }
            />
            
            <Route
              path="*"
              element={
                <RequireAuth>
                  <Admin />
                </RequireAuth>
              }
            />
          </Routes>
        </BrowserRouter>
      </AntApp>
    </ErrorBoundry>
  );
};

export default App;
